import React, { Component } from 'react';
// import { Parallax } from 'react-skrollr'

import styles from  './styles.js';

class HvadEr extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
		});

		return (
			<div style={elmStyl} className='community'>
				<div style={styles.flex}>
					<div style={styles.textComponent}>
						<div style={styles.textComponentInner}>
							<h1>Byg et digt - er også, et rum for fællesskab</h1>
							<div>
								<p>
								Et fri-rum hvor
								hygge, sjov og nærvær er i fokus.
								der ikke skal præsteres efter forskrifter. 
								Reglen er, at der ingen regler er.  “Så det kan man godt”
								og et rum for at være fælles om at skabe.
								</p>
								<p>
								Overgiv dig - til poesien ordet & poesien 
								Rammen er sat. Ordene er sirligt skåret ud ved håndkraft og ligger parat som små byggeklodser. Deres forskellige fonte, farver og betydning tiltrækker sig visuel opmærksomhed og inviterer uden særlige forudsætninger, til en kreativ leg med form og ord.
								</p>								
							</div>
						</div>
					</div>
						
				</div>
			</div>

		)
	}
}

export default HvadEr;





// WEBPACK FOOTER //
// ./src/components/HvadErRum.js